import { FC } from 'react'
import classes from './index.module.css'
import type { PhoneIntegrationButtonsProps } from './phoneIntegrationButtons.types'
import { usePhoneIntegrationButtons } from './usePhoneIntegrationButtons'
// Legacy Wazzup iframe icons (зелёный WA/TG) — отключены: дубль нового WZ-чата.
// import LegacyWazzupIntegrationIcons from './components/LegacyWazzupIntegrationIcons'
import ProviderIconsStack from './components/ProviderIconsStack'
import TelephonyCallModal from './components/TelephonyCallModal'
// import WazzupIframeModal from './components/WazzupIframeModal'

const PhoneIntegrationButtons: FC<PhoneIntegrationButtonsProps> = (props) => {
  const {
    tooltipProps,
  } = props
  const {
    // vkOnly,
    // showWazzupIntegrations,
    phoneNumber,
    vkUnreadBadgeSize,
    useStackedIconLook,
    showTelephonyInStack,
    telephonyEndpoints,
    providerButtons,
    // legacyIntegrations,
    // openLegacyWazzupIframe,
    // stateModal,
    // setStateModal,
    telephonyModal,
    setTelephonyModal,
    callLoading,
    startTelephonyCall,
  } = usePhoneIntegrationButtons(props)

  return (
    <div className={classes.list}>
      {/* Legacy: иконки whatsapp/tgapi + iframe из integration-wazzup/index
      {!vkOnly && showWazzupIntegrations ? (
        <LegacyWazzupIntegrationIcons
          integrations={legacyIntegrations}
          tooltipProps={tooltipProps}
          onOpen={openLegacyWazzupIframe}
        />
      ) : null}
      */}

      <ProviderIconsStack
        badgeSize={vkUnreadBadgeSize}
        useStackedIconLook={useStackedIconLook}
        tooltipProps={tooltipProps}
        showTelephony={showTelephonyInStack}
        telephonyEndpoints={telephonyEndpoints}
        phoneNumber={phoneNumber}
        onPickTelephonyEndpoint={(endpoint) =>
          setTelephonyModal({
            endpoint,
            extension: endpoint.outgoing_users?.[0]?.extension ?? '',
            lineNumber: endpoint.outgoing_lines?.[0]?.number ?? '',
          })
        }
        buttons={providerButtons}
      />

      {/* Legacy iframe modal
      <WazzupIframeModal
        state={stateModal}
        onClose={() => setStateModal({ open: false })}
      />
      */}

      <TelephonyCallModal
        state={telephonyModal}
        phoneNumber={phoneNumber}
        callLoading={callLoading}
        onChange={setTelephonyModal}
        onClose={() =>
          setTelephonyModal({ endpoint: null, extension: '', lineNumber: '' })
        }
        onCall={() => void startTelephonyCall()}
      />
    </div>
  )
}

export default PhoneIntegrationButtons
export type { PhoneIntegrationButtonsProps } from './phoneIntegrationButtons.types'
